export enum CustomerPortalPermission {
  Dashboard = 'Dashboard',
  AddUser = 'Add User',
  EditUser = 'Edit User',
  DeleteUser = 'Delete User',
  ManageRoles = 'Manage Roles',
}
